var map = {
	"./America.png": "f1dc",
	"./Argentina.png": "3091",
	"./Australia.png": "4e33",
	"./Belarus.png": "f353",
	"./Bolivia.png": "329a",
	"./Brazil.png": "f2e8",
	"./Britain.png": "1216",
	"./Canada.png": "9780",
	"./Chile.png": "878a",
	"./CostaRica.png": "a5aa",
	"./France.png": "a023",
	"./Hungary.png": "d84c",
	"./Ireland.png": "66b7",
	"./Italy.png": "2007",
	"./Kazakhstan.png": "44a9",
	"./Latvia.png": "733e",
	"./Lithuania.png": "7304",
	"./Mexico.png": "38b7",
	"./Mongolia.png": "a02c",
	"./Namibia.png": "fedb",
	"./Netherlands.png": "8b41",
	"./NewZealand.png": "0486",
	"./Panama.png": "51cc",
	"./Russia.png": "ae9c",
	"./Serbia.png": "7aa3",
	"./SouthAfrica.png": "5180",
	"./TheUnitedKingdom.png": "a4c2",
	"./TheUnitedStates.png": "12d7",
	"./Ukraine.png": "ae54",
	"./Uruguay.png": "7ff1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a05";